import { IDimensionProps } from '@grubhubprod/gh-cookbook-react';

export const getPageSectionBorderRadius = (
  isBalanceUiEnabled: boolean,
  isBalanceUiLoading: boolean,
  customBorderRadius: string
): string => {
  if (customBorderRadius) {
    return customBorderRadius;
  }

  if (!isBalanceUiLoading && isBalanceUiEnabled) {
    return '8px';
  }

  return '4px';
};

export const getPageSectionDimension = (
  isBalanceUiEnabled: boolean,
  isBalanceUiLoading: boolean
): IDimensionProps['dimension'] => {
  if (!isBalanceUiLoading && isBalanceUiEnabled) {
    return null;
  }

  return '2';
};
